// Reine Helfer für die Profil-Seite.

export const calculateAge = (birthDate) => {
    if (!birthDate) return null;
    const today = new Date();
    const birth = new Date(birthDate);
    let age = today.getFullYear() - birth.getFullYear();
    const monthDiff = today.getMonth() - birth.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
        age--;
    }
    return age;
};

export const formatDate = (date) => {
    if (!date) return "Nicht angegeben";
    return new Date(date).toLocaleDateString("de-DE", {
        day: "2-digit",
        month: "long",
        year: "numeric",
    });
};

export const getGeschlechtLabel = (geschlecht) => {
    const labels = { m: "Männlich", w: "Weiblich", d: "Divers" };
    return labels[geschlecht] || "Nicht angegeben";
};

export const formatBytes = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
};
